import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import { bg_button } from "constant/css";
const data = [
  {
    id: null,
    name: "сонго",
  },
  {
    id: "050000",
    name: "Хаан банк",
  },
  {
    id: "340000",
    name: "Төрийн банк",
  },
  {
    id: "150000",
    name: "Голомт банк",
  },
  {
    id: "390000",
    name: "М Банк",
  },
  {
    id: "040000",
    name: "Худалдаа хөгжлийн банк",
  },
  {
    id: "300000",
    name: "Капитрон банк",
  },
  {
    id: "320000",
    name: "Хас банк",
  },
];
const BankSelectModal = ({ open, close, save, value }) => {
  const [bankCode, setBankCode] = useState(value);
  return (
    <Modal
      open={open}
      closeIcon={null}
      size={350}
      width={200}
      footer={null}
      title="Банк сонгох"
      onCancel={close}
    >
      <Select
        value={value}
        onChange={(e) => {
          //console.log(e);
          setBankCode(e);
        }}
        style={{ width: "100%" }}
      >
        {data.map((bank) => (
          <Select.Option key={bank.id} value={bank.id}>
            {bank.name}
          </Select.Option>
        ))}
      </Select>
      <div className="flex flex-col gap-2 mt-4 w-full items-center">
        <button
          className={`${bg_button} text-white items-center justify-center rounded-md flex center w-[100px] `}
          onClick={() => save(bankCode)}
        >
          Хадгалах
        </button>
      </div>
    </Modal>
  );
};

export default BankSelectModal;
